import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalService } from 'src/app/services/modal.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PersistenceService } from 'src/app/services/persistence.service';

@Component({
  selector: 'app-initial-login',
  templateUrl: './initial-login.component.html',
  styleUrl: './initial-login.component.scss'
})
export class InitialLoginComponent {
  isSubmitting = false;
  isFormCompleted = false;
  loginID;
  regcode;
  errorMsg;

  constructor(
    private authenticationService:AuthenticationService,
    private navigationService: NavigationService,
    private persistenceService: PersistenceService,
    private modalService: ModalService,
    private router: Router){
  }

  forward(){
    if(!this.isSubmitting){
      this.isFormCompleted = true;
      this.isSubmitting = true;
      const creds: any = {};
      if (this.loginID) {
        creds.username = this.loginID;
        creds.password = 'password';
        this.authenticationService.initialLogin(creds, this.regcode).then(() => {
          // promise resolved
          if(this.regcode){
            this.authenticationService.mapRegCode(this.regcode);
          }
          this.navigationService.forward();
        }, (err) => {
          this.isSubmitting =false;
          this.errorMsg = err;
        });
      } else {
        this.isSubmitting =false;
        this.errorMsg = 'Please enter a Login ID.';
      }
    }
  }
  declineButtonClick() {

    this.persistenceService.testStorage();
    this.persistenceService.clear();

    const creds: any = {};
    console.log(this.loginID);
    creds.username = this.loginID;
    creds.password = 'password';

    if (this.loginID) {
      this.authenticationService.initialLogin(creds, this.regcode).then(() => {
        //  promise resolved
        //this.router.navigate(['/invitation']);
        this.authenticationService.updateProfile('CANCELLED', "Declined from Login Page").subscribe(() => {
          this.router.navigate(['decline']);
      });

      }, (err) => {
        this.errorMsg = err;
      });
    }

  }

  backhome() {
    //redirect to content site
    const env = window.location.hostname;

    if (env.indexOf('localhost') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('local') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('dev') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('test') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('content') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    }
  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }
}
